import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ac2cc1cc"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("已开启");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("未开启");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("解绑");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存");

import { ElMessage } from 'element-plus';
import { computed, nextTick, ref, watch } from 'vue';
import { bindSmartkbTenant, getSmartkbTenants } from '@/request';
export default {
  name: 'BindSmartkbTenantModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    // 控销团队行数据：supplierId / smartkbTenantSlug / smartkbTenantName
    team: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const PLAN_LABELS = {
      free: '免费版',
      pro: '专业版',
      enterprise: '企业版'
    };
    const tenantTable = ref();
    const tenantList = ref([]);
    const keyword = ref(''); // 当前勾选的租户 slug；与表格 radio 分离，搜索过滤后仍能保留选择

    const selectedSlug = ref('');
    const loading = ref(false);
    const saving = ref(false);
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const boundSlug = computed(() => {
      var _props$team;

      return ((_props$team = props.team) === null || _props$team === void 0 ? void 0 : _props$team.smartkbTenantSlug) || '';
    }); // 已绑定但不在可选列表里：租户已被停用

    const staleSlug = computed(() => {
      if (!boundSlug.value || loading.value) return '';
      return tenantList.value.some(t => t.slug === boundSlug.value) ? '' : boundSlug.value;
    });
    const filteredList = computed(() => {
      const kw = keyword.value.trim().toLowerCase();
      if (!kw) return tenantList.value;
      return tenantList.value.filter(t => (t.name || '').toLowerCase().includes(kw) || (t.slug || '').toLowerCase().includes(kw));
    }); // 过滤结果变化后同步表格 radio 状态

    watch(filteredList, () => syncRadio());

    function planFormatter({
      row
    }) {
      return PLAN_LABELS[row.plan] || row.plan || '-';
    }

    function onRadioChange({
      row
    }) {
      selectedSlug.value = row.slug;
    }

    function syncRadio() {
      return _syncRadio.apply(this, arguments);
    }

    function _syncRadio() {
      _syncRadio = _asyncToGenerator(function* () {
        yield nextTick();
        const table = tenantTable.value;
        if (!table) return;
        const row = filteredList.value.find(t => t.slug === selectedSlug.value);

        if (row) {
          table.setRadioRow(row);
        } else {
          table.clearRadioRow();
        }
      });
      return _syncRadio.apply(this, arguments);
    }

    function load() {
      return _load.apply(this, arguments);
    }

    function _load() {
      _load = _asyncToGenerator(function* () {
        loading.value = true;
        keyword.value = '';
        tenantList.value = [];
        selectedSlug.value = '';

        try {
          const res = yield getSmartkbTenants();

          if (!res.success) {
            ElMessage.error(res.msg || '获取租户列表失败');
            return;
          }

          tenantList.value = res.data || [];

          if (tenantList.value.some(t => t.slug === boundSlug.value)) {
            selectedSlug.value = boundSlug.value;
          }

          yield syncRadio();
        } finally {
          loading.value = false;
        }
      });
      return _load.apply(this, arguments);
    }

    function save(_x) {
      return _save.apply(this, arguments);
    }

    function _save() {
      _save = _asyncToGenerator(function* (tenant) {
        saving.value = true;

        try {
          const res = yield bindSmartkbTenant({
            supplierId: props.team.supplierId,
            tenantSlug: (tenant === null || tenant === void 0 ? void 0 : tenant.slug) || '',
            tenantName: (tenant === null || tenant === void 0 ? void 0 : tenant.name) || ''
          });

          if (!res.success) {
            ElMessage.error(res.msg || '保存失败');
            return;
          }

          ElMessage.success(tenant ? '绑定成功' : '已解绑');
          visible.value = false;
          emit('success');
        } finally {
          saving.value = false;
        }
      });
      return _save.apply(this, arguments);
    }

    function confirm() {
      const tenant = tenantList.value.find(t => t.slug === selectedSlug.value);

      if (!tenant) {
        ElMessage.error('请选择租户后再保存!');
        return;
      }

      save(tenant);
    }

    function unbind() {
      save(null);
    }

    return (_ctx, _cache) => {
      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_input = _resolveComponent("el-input");

      const _component_vxe_column = _resolveComponent("vxe-column");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_vxe_table = _resolveComponent("vxe-table");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "绑定智能客服租户",
        width: "1100px",
        onOpen: load
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _unref(boundSlug) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          plain: "",
          loading: saving.value,
          onClick: unbind
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }, 8, ["loading"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          loading: saving.value,
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_unref(staleSlug) ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          type: "warning",
          closable: false,
          "show-icon": "",
          class: "stale-tip",
          title: `当前绑定的租户「${_unref(staleSlug)}」已不可用（已停用），请重新选择或解绑`
        }, null, 8, ["title"])) : _createCommentVNode("", true), _createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          class: "search-input",
          placeholder: "按租户名称 / 标识搜索",
          "prefix-icon": "Search",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_el_scrollbar, {
          height: "50vh"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_table, {
            align: "center",
            data: _unref(filteredList),
            loading: loading.value,
            "radio-config": {
              highlight: true,
              trigger: 'row'
            },
            ref_key: "tenantTable",
            ref: tenantTable,
            onRadioChange: onRadioChange
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_column, {
              type: "radio",
              width: "50"
            }), _createVNode(_component_vxe_column, {
              field: "name",
              title: "租户名称",
              "min-width": "140",
              "show-overflow": ""
            }), _createVNode(_component_vxe_column, {
              field: "slug",
              title: "租户标识",
              width: "130",
              "show-overflow": ""
            }), _createVNode(_component_vxe_column, {
              title: "联查授权",
              width: "90"
            }, {
              default: _withCtx(({
                row
              }) => [row.allowJointQuery ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                type: "success",
                size: "small"
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                content: "可先绑定；SmartKB 平台开启该租户联查授权后，App 客服才会检索其知识库",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tag, {
                  type: "info",
                  size: "small"
                }, {
                  default: _withCtx(() => [_hoisted_2]),
                  _: 1
                })]),
                _: 1
              }))]),
              _: 1
            }), _createVNode(_component_vxe_column, {
              title: "套餐类型",
              width: "90",
              formatter: planFormatter
            }), _createVNode(_component_vxe_column, {
              field: "maxAgents",
              title: "客服上限",
              width: "90"
            }), _createVNode(_component_vxe_column, {
              field: "maxDocuments",
              title: "文档上限",
              width: "90"
            }), _createVNode(_component_vxe_column, {
              field: "maxSessionsPerDay",
              title: "日会话上限",
              width: "100"
            }), _createVNode(_component_vxe_column, {
              field: "agentCount",
              title: "客服数量",
              width: "90"
            }), _createVNode(_component_vxe_column, {
              field: "createdAt",
              title: "创建时间",
              width: "150"
            })]),
            _: 1
          }, 8, ["data", "loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};